module.exports = __webpack_public_path__ + "img/smart-scan-char-4.495dede7.png";